export enum WorkspaceListType {
    LIST = 'list',
    TILE = 'tile',
}
